import { anonymousPlayer } from '../initialStates'
import { setAppTokenLocalStorage } from '../utils'

/**
 * generalReducer
 *
 * @desc
 *  A reducer that computes all state.
 *  Contains one action to reset all context states on logout
 */

const generalActions = {
  // reset all non zustand data
  // remove after full migration
  resetAllContextData: () => {
    setAppTokenLocalStorage(anonymousPlayer)

    return anonymousPlayer
  }
}

const generalReducer = (state, action) => generalActions[action.type]()

export default generalReducer
